export { default, lcm } from 'ember-math-helpers/helpers/lcm';
